import { format, parseISO, getMonth, getYear } from 'date-fns';
import './BookingConfirmation.css';

const BookingConfirmationTable = ({ finalDesks, totalPrice, bookingType, discountCode, discountPercentage, discountAmount, originalPrice }) => {

    const sortedKeys = Object.keys(finalDesks).sort((a, b) => new Date(a) - new Date(b));

    const isCurrentMonth = (dateString) => {
        const bookingDate = parseISO(dateString);
        const today = new Date();
        return getMonth(bookingDate) === getMonth(today) && getYear(bookingDate) === getYear(today);
    };

    return (
        <div className='booking-confirmation-table'>
            {bookingType === "daily" && (
                <table>
                    <tbody>
                        {sortedKeys.map((date) => {
                            const desk = finalDesks[date];
                            return (
                                <tr key={date}>
                                    <td>
                                        {format(parseISO(date), "EEE d MMM yyyy")} (7am-7pm)
                                    </td>
                                    <td>Desk {desk.id}</td>
                                    <td>£{desk.price}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        {discountCode && discountAmount && (
                            <>
                                <tr>
                                    <td></td>
                                    <td><strong>Subtotal</strong></td>
                                    <td><strong>£{originalPrice}</strong></td>
                                </tr>
                                <tr style={{ color: '#28a745' }}>
                                    <td></td>
                                    <td><strong>Discount ({discountPercentage}% off)</strong></td>
                                    <td><strong>-£{discountAmount}</strong></td>
                                </tr>
                            </>
                        )}
                        <tr>
                            <td></td>
                            <td><strong>Total</strong></td>
                            <td><strong>£{totalPrice}</strong></td>
                        </tr>
                    </tfoot>
                </table>
            )
            }
            {
                bookingType === "monthly" && (
                    <table>
                        <tbody>
                            {sortedKeys.map((date) => {
                                const desk = finalDesks[date];
                                return (
                                    <tr key={date}>
                                        <td>
                                            {format(parseISO(date), "MMM yyyy")} (weekdays: 7am-7pm)
                                            {isCurrentMonth(date) && (
                                                <span style={{ "fontSize": "12px", "marginLeft": "10px" }}> *pro-rated from 1st</span>
                                            )}
                                        </td>
                                        <td>Desk {desk.id}</td>
                                        <td>£{desk.price}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            {discountCode && discountAmount && (
                                <>
                                    <tr>
                                        <td></td>
                                        <td><strong>Subtotal</strong></td>
                                        <td><strong>£{originalPrice}</strong></td>
                                    </tr>
                                    <tr style={{ color: '#28a745' }}>
                                        <td></td>
                                        <td><strong>Discount ({discountPercentage}% off)</strong></td>
                                        <td><strong>-£{discountAmount}</strong></td>
                                    </tr>
                                </>
                            )}
                            <tr>
                                <td></td>
                                <td><strong>Total</strong></td>
                                <td><strong>£{totalPrice}</strong></td>
                            </tr>
                        </tfoot>
                    </table>
                )
            }
        </div >
    );
}

export default BookingConfirmationTable;